module.exports = __webpack_public_path__ + "media/images/logo/nuevo_logo-76a3cd760510647b2544bb820252058b.jpg";